import React from "react";
import { Fab, Box, useTheme, Tooltip } from "@mui/material";
import { AddCircleOutline, FilterAltOutlined } from "@mui/icons-material";
import FactCheckIcon from "@mui/icons-material/FactCheck";

export interface ActionButton {
  icon: React.ReactNode;
  title: string;
  onClick?: () => void;
  disabled?: boolean;
  active?: boolean;
}

interface ActionToolbarProps {
  onIncluir?: () => void;
  onFiltrar?: () => void;
  onOrganizarColunas?: () => void;
  mostrarIncluir?: boolean;
  mostrarFiltrar?: boolean;
  mostrarOrganizarColunas?: boolean;
  filtrosAtivos?: boolean;
  customButtons?: ActionButton[];
  disabledIncluir?: boolean;
  disabledFiltrar?: boolean;
  disabledOrganizarColunas?: boolean;
}

// Barra de ações padrão das listagens (mesmo padrão visual do XC WMS)
const ActionToolbar: React.FC<ActionToolbarProps> = ({
  onIncluir,
  onFiltrar,
  onOrganizarColunas,
  mostrarIncluir = true,
  mostrarFiltrar = true,
  mostrarOrganizarColunas = false,
  filtrosAtivos = false,
  customButtons = [],
  disabledIncluir = false,
  disabledFiltrar = false,
  disabledOrganizarColunas = false,
}) => {
  const theme = useTheme();

  const defaultStyle = {
    bgcolor: "#ffa226",
    color: "white",
    "&:hover": {
      bgcolor: theme.palette.warning.light,
    },
  };

  const activeFilterStyle = {
    bgcolor: theme.palette.warning.light,
    color: "white",
    "&:hover": {
      bgcolor: theme.palette.warning.light,
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: 2,
        gap: 2,
      }}
    >
      {mostrarIncluir && (
        <Tooltip title="Incluir" arrow>
          <span>
            <Fab
              size="small"
              onClick={onIncluir}
              disabled={disabledIncluir || !onIncluir}
              sx={defaultStyle}
            >
              <AddCircleOutline />
            </Fab>
          </span>
        </Tooltip>
      )}

      {mostrarFiltrar && (
        <Tooltip title="Filtrar" arrow>
          <span>
            <Fab
              size="small"
              onClick={onFiltrar}
              disabled={disabledFiltrar || !onFiltrar}
              sx={filtrosAtivos ? activeFilterStyle : defaultStyle}
            >
              <FilterAltOutlined />
            </Fab>
          </span>
        </Tooltip>
      )}

      {customButtons.map((button, index) => (
        <Tooltip key={index} title={button.title} arrow>
          <span>
            <Fab
              size="small"
              onClick={button.onClick}
              disabled={button.disabled}
              sx={button.active ? activeFilterStyle : defaultStyle}
            >
              {button.icon}
            </Fab>
          </span>
        </Tooltip>
      ))}

      {mostrarOrganizarColunas && (
        <Tooltip title="Preferências" arrow>
          <span>
            <Fab
              size="small"
              onClick={onOrganizarColunas}
              disabled={disabledOrganizarColunas || !onOrganizarColunas}
              sx={defaultStyle}
            >
              <FactCheckIcon />
            </Fab>
          </span>
        </Tooltip>
      )}
    </Box>
  );
};

export default ActionToolbar;
